import React, { Component } from 'react'
import moment from 'moment';
import { Datos_Empresa, development, decodeText } from "../../../libs/utils/Const";


class Kardex extends Component {

    DocumentType = (ObjType) => {

        let name = "";
        switch (ObjType) {
            case 10000071:
                name = 'Contabilización de inventario';
                break;
            case 132:
                name = 'Factura de corrección';
                break;
            case 13:
                name = 'Factura de deudores';
                break;
            case 14:
                name = 'Nota de crédito de deudores';
                break;
            case 162:
                name = 'Revaluación de inventario';
                break;
            case 15:
                name = 'Entregas';
                break;
            case 16:
                name = 'Devoluciones';
                break;
            case 18:
                name = 'Factura de acreedores';
                break;
            case 19:
                name = 'Nota de crédito de acreedores';
                break;
            case 20:
                name = 'Entrada de mercancías';
                break;
            case 21:
                name = 'Devolución de mercancías';
                break;
            case 310000001:
                name = 'Cantidad inicial';
                break;
            case 58:
                name = 'Actualización de existencias';
                break;
            case 59:
                name = 'Entrada de mercancías';
                break;
            case 60:
                name = 'Salida de mercancías';
                break;
            case 67:
                name = 'Transferencia de inventario';
                break;
            default:
                break;
        }

        return name;
    }
    render() {
        const { DocsToPrint, ReportsModel } = this.props;
        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />{/*<strong>{"InfoByFolio ? InfoByFolio.folio : ''"}</strong>*/}</p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE KARDEX</strong></h5>
                            </div>
                            <div className="col-3">
                                <p>{Datos_Empresa.Calle} #{Datos_Empresa.Numero} <br />COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP} <br />SUCURSAL: {DocsToPrint[0].currentUser ? DocsToPrint[0].currentUser.Sucursal : 'Sin sucursal'}</p>
                            </div>
                        </div>

                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className="col-12">
                                <p>ARTICULO: {ReportsModel.ItemCode}<br />DESCRIPCIÓN: {ReportsModel.ItemName} <br />ALMACEN: {decodeText(ReportsModel.WhsName)} <br />MOVIMIENTOS: Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')} </p>
                            </div>
                            <div className='col-12'>
                                <table>
                                    <thead style={{ border: "solid 1px" }}>
                                        <tr>
                                            <th className="text-left">Tipo</th>
                                            <th className="text-left">Folio</th>
                                            <th className="text-left">Fecha</th>
                                            <th className="text-right">Ingresos</th>
                                            <th className="text-right">Egresos</th>
                                            <th className="text-right">Existencia</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!!DocsToPrint[0].ListKardex && DocsToPrint[0].ListKardex.map((kardex, index) => {
                                            
                                            return (
                                                <tr style={{ fontSize: '12px' }}>
                                                    <td className="text-left">{this.DocumentType(kardex.TransType)}</td>
                                                    <td className="text-left">{kardex.NumAtCard && kardex.NumAtCard !== '' ? kardex.NumAtCard : kardex.DocNum}</td>
                                                    <td className="text-left">{moment(kardex.TaxDate).utc().format('MM/DD/YYYY')}</td>
                                                    <td className="text-right">{Number(kardex.InQty).toFixed(2)}</td>
                                                    <td className="text-right">{Number(kardex.OutQty).toFixed(2)}</td>
                                                    <td className="text-right">{Number(kardex.Exist).toFixed(2)}</td>
                                                </tr>
                                            );
                                        })}
                                        <br />

                                        <tr style={{ borderTop: "solid 1px" }}>
                                            <td colspan="4" className="text-left">{DocsToPrint[0].ListKardex.length}</td>
                                            <td className="text-right"><strong>Existencia: </strong></td>
                                            <td className="text-right"><strong>{Number(DocsToPrint[0].ListKardex[0].OnHand).toFixed(2)}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </td></tr></table>
            </>
        )
    }
}

export default Kardex